import React from 'react'
import { Card, List, Typography } from 'antd'
import { Link } from 'react-router-dom'
import CustomList from '../../components/Shared/CustomList'
import {
	GeneralContentWrapper,
	GeneralTitle
} from '../../components/Shared/GeneralComponents'

const { Title, Paragraph } = Typography

const entities = [
	{
		name: 'Webackit Solutions S.R.L.',
		region: 'EU clients',
		address: 'Str. Splaiul Independenței, nr.202B, București, Romania',
		fiscal: 'RO44553258',
		register: 'J40/11711/2021'
	},
	{
		name: 'Webackit LLC',
		region: 'US clients',
		address: '6847, 1021 E Lincolnway, Cheyenne, WY 82001, USA',
		fiscal: '612194135'
	}
]

const TermsAndConditions = () => (
	<GeneralContentWrapper>
		<GeneralTitle text="Terms & Conditions" />

		<Title level={3}>1. Responsible Entity</Title>
		<Paragraph>
			Services are provided by the entity corresponding to your business
			location. Both entities are owned by Recu Daniel.
		</Paragraph>
		{entities.map((e) => (
			<Card key={e.name} style={{ marginBottom: 16 }}>
				<Title level={4}>
					{e.name} <small>({e.region})</small>
				</Title>
				<Paragraph>{e.address}</Paragraph>
				<Paragraph>Fiscal Number: {e.fiscal}</Paragraph>
				{e.register && (
					<Paragraph>Commercial Register: {e.register}</Paragraph>
				)}
			</Card>
		))}

		<Title level={3}>2. Scope of Services</Title>
		<CustomList
			dataSource={[
				{
					title: 'Monthly subscription plans, billed automatically via Stripe.'
				},
				{
					title: 'One-time service purchases, invoiced and paid via Stripe.'
				},
				{
					title: 'All features and add-ons described on the platform are subject to plan level.'
				}
			]}
			renderItem={(item) => <List.Item>{item.title}</List.Item>}
		/>

		<Title level={3}>3. Subscription Terms</Title>
		<CustomList
			dataSource={[
				{
					title: 'Subscriptions renew automatically each month until canceled.'
				},
				{
					title: 'You may cancel at any time; cancellation takes effect at end of current billing period.'
				},
				{ title: 'No prorated refunds for mid-period cancellations.' }
			]}
			renderItem={(item) => <List.Item>{item.title}</List.Item>}
		/>

		<Title level={3}>4. One-Time Services</Title>
		<CustomList
			dataSource={[
				{
					title: 'Individual services require full payment in advance.'
				},
				{
					title: 'Scope, specifications, and final pricing confirmed before work begins.'
				},
				{
					title: 'Provider reserves right to decline or revise orders based on feasibility.'
				}
			]}
			renderItem={(item) => <List.Item>{item.title}</List.Item>}
		/>

		<Title level={3}>5. Payments</Title>
		<Paragraph>
			All payments are processed securely via Stripe. You agree to provide
			accurate billing information and authorize charges.
		</Paragraph>

		<Title level={3}>6. Account Security</Title>
		<Paragraph>
			You are responsible for maintaining confidentiality of your account
			credentials and for all activity under your account.
		</Paragraph>

		<Card>
			<Title level={3}>7. Cookies & Performance Data</Title>
			<Paragraph>
				We use cookies and local storage to cache temporary data (user
				actions, preferences, query results) to speed up the platform
				and reduce repeated API calls.
			</Paragraph>
		</Card>

		<Card>
			<Title level={3}>8. Intellectual Property</Title>
			<Paragraph>
				All content, code, logos, and trademarks on the platform are
				owned by the responsible entity. Unauthorized use is prohibited.
			</Paragraph>
		</Card>

		<Title level={3}>9. Governing Law</Title>
		<Paragraph>
			EU clients: governed by Romanian law and EU regulations (including
			GDPR). US clients: governed by the laws of Wyoming, USA (including
			CCPA where applicable).
		</Paragraph>

		<Title level={3}>10. Limitation of Liability</Title>
		<Paragraph>
			Neither entity is liable for indirect, special, or consequential
			damages arising from use of the platform.
		</Paragraph>

		<Title level={3}>11. Changes to Terms</Title>
		<Paragraph>
			We may modify these Terms at any time; significant changes will be
			communicated via email or in-app notification.
		</Paragraph>

		<Card>
			<Title level={3}>12. Privacy Policy</Title>
			<Paragraph>
				For details on data handling, see our{' '}
				<Link to="privacy-policy">Privacy Policy</Link>.
			</Paragraph>
		</Card>

		<Title level={3}>13. Contact</Title>
		<Paragraph>Email: contact@on-subscription.com</Paragraph>
		<Paragraph>Phone: +40 748 702 852</Paragraph>
	</GeneralContentWrapper>
)

export default TermsAndConditions
